<ul>
  @for (item of drawerItems; track $index) {
    <li [class.margin-top]="$index === 0 && !item.isTitle">
      @if (item.children.length && item.route === '') {
        <div
          class="link flex"
          [class.active]="item.isActive"
          (click)="onDrawerItemClick(item)"
          (keydown.enter)="onDrawerItemClick(item)"
        >
          <span>{{
            'dashboardOverview.navigation.' + item.label + '.label' | transloco
          }}</span>

          <markant-icon
            class="material-icons"
            colorScheme="light"
            slot="icon-leading"
            [icon]="item.isCollapsed ? 'm_chevron-down' : 'm_chevron-up'"
          >
          </markant-icon>
        </div>
      } @else if (item.isTitle) {
        <div class="title" [class.margin-top]="$index !== 0">
          @if ($labelHasTranslation()) {
            <span>{{
              'dashboardOverview.navigation.' + item.label + '.label'
                | transloco
            }}</span>
          } @else {
            <span>{{ item.label }}</span>
          }
        </div>
      } @else {
        <a
          class="link"
          data-cy="navigation-drawer-click"
          [routerLink]="item.route"
          [routerLinkActive]="['active']"
        >
          <span>{{
            'dashboardOverview.navigation.' + item.label + '.label' | transloco
          }}</span>
        </a>
      }

      @if (!item.isCollapsed && item.children.length) {
        <markant-platform-navigation-accordion
          [drawerItems]="item.children"
        ></markant-platform-navigation-accordion>
      }
    </li>
  }
</ul>
